module.exports = __webpack_public_path__ + "static/media/M007-account-noprivilege.03ab71a3.svg";